export const jackpotRouletteFields = [
  {
    label: 'ROUND ID',
    key: 'identifierNumber',
    class: 'space-nowrap',
  },
  {
    label: 'GAME',
    key: 'game',
    class: 'space-nowrap',
  },
  {
    label: 'JACKPOTS',
    key: 'jackpot_values',
  },
  {
    label: 'RESULT',
    key: 'resultNumber',
  },
  {
    label: 'PLAYER',
    key: 'username',
  },
  {
    label: 'PLAYER ID',
    key: 'userId',
    class: 'space-nowrap',
  },
  {
    label: 'OPERATOR',
    key: 'operator',
  },
  {
    label: 'DEBIT',
    key: 'betAmount',
  },
  {
    label: 'CREDIT',
    key: 'amount',
  },
  {
    label: 'CURRENCY',
    key: 'currency',
  },
  {
    label: 'TRANSACTION ID',
    key: 'transactionId',
    class: 'space-nowrap',
  },
  // {
  //   label: 'DETALLE',
  //   key: 'details',
  // },
  {
    label: 'FECHA',
    key: 'createdAt',
    class: 'space-nowrap',
  },
];

export const jackpotWheelFields = [
  {
    label: 'ROUND ID',
    key: 'round.identifierNumber',
    class: 'space-nowrap',
  },
  {
    label: 'GAME',
    key: 'game.name',
    class: 'space-nowrap',
  },
  {
    label: 'JACKPOTS',
    key: 'jackpots',
  },
  {
    label: 'PLAYER',
    key: 'player.username',
  },
  {
    label: 'PLAYER ID',
    key: 'player.userId',
    class: 'space-nowrap',
  },
  {
    label: 'OPERATOR',
    key: 'player.operator.name',
  },
  {
    label: 'DEBIT',
    key: 'bet.totalAmount',
  },
  {
    label: 'CREDIT',
    key: 'amount',
  },
  {
    label: 'CURRENCY',
    key: 'currency.isoCode',
  },
  {
    label: 'TRANSACTION ID',
    key: 'bet.uuid',
    class: 'space-nowrap',
  },
  {
    label: 'DETALLE',
    key: 'details',
  },
  {
    label: 'FECHA',
    key: 'createdAt',
    class: 'space-nowrap',
  },
];
